/** @format */

import buttonGroupStyle from 'assets/jss/material-dashboard-pro-react/buttonGroupStyle.jsx';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import loaderStyle from 'assets/jss/adescom/loaderStyle.js';
import adescomTableStyle from 'assets/jss/adescom/adescomTableStyle';
import selectFromRestStyle from 'assets/jss/adescom/selectFromRestStyle';
import paginationCss from 'assets/jss/adescom/pagination';

import {
    cardTitle,
    dangerColor,
    // whiteColor,
    // grayColor
} from 'assets/jss/material-dashboard-pro-react.jsx';

const adescomStyle = {
    ...customCheckboxRadioSwitch,
    ...buttonGroupStyle,
    ...loaderStyle,
    ...sweetAlertStyle,
    ...adescomTableStyle,
    ...selectFromRestStyle,
    ...paginationCss,

    right: {
        textAlign: 'right',
    },
    center: {
        textAlign: 'center',
    },
    description: {
        maxWidth: '150px',
    },
    hoverable: {
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
    },
    actionButton: {
        margin: '0 0 0 5px',
        padding: '5px',
        '& svg,& .fab,& .fas,& .far,& .fal,& .material-icons': {
            marginRight: '0px',
        },
    },
    icon: {
        verticalAlign: 'middle',
        width: '17px',
        height: '17px',
        top: '-1px',
        position: 'relative',
    },
    imgContainer: {
        width: '120px',
        maxHeight: '160px',
        overflow: 'hidden',
        display: 'block',
    },
    img: {
        width: '100%',
        height: 'auto',
        verticalAlign: 'middle',
        border: '0',
    },
    positionAbsolute: {
        position: 'absolute',
        right: '0',
        top: '0',
    },
    customFont: {
        fontSize: '16px !important',
    },
    actionButtonRound: {
        width: 'auto',
        height: 'auto',
        minWidth: 'auto',
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: '15px',
        marginBottom: '0px',
    },
    danger: {
        color: dangerColor[0] + '!important',
    },
    btnNotActive: {
        borderBottom: 5,
        borderBottomColor: 'transparent',
        borderBottomStyle: 'solid',
        transition: 'border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    btnActive: {
        borderBottom: 5,
        borderBottomColor: '#00acc1',
        borderBottomStyle: 'solid',
        transition: 'border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
};

export default adescomStyle;
